/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SigneringAnmodningInfo } from '../models/signering-anmodning-info';
import { OrderSignering } from '../models/order-signering';
import { DokumentationReference } from '../models/dokumentation-reference';
import { FileStreamResult } from '../models/file-stream-result';
import { SigneringBilag } from '../models/signering-bilag';
import { MitIdSigneringRequest } from '../models/mit-id-signering-request';
import { ValiderSigneringResult } from '../models/valider-signering-result';
import { ValiderSigneringRequest } from '../models/valider-signering-request';
@Injectable({
  providedIn: 'root',
})
class SigneringService extends __BaseService {
static readonly getAnmodningPath = '/signering/anmodning';
static readonly orderPath = '/signering/anmodning';
static readonly revokeRequestPath = '/signering/anmodning';
static readonly downloadPath = '/signering/dokument';
static readonly uploadPath = '/signering/dokument';
static readonly deleteSigneringDokumentPath = '/signering/dokument';
static readonly getSigneringTicketBilagPath = '/signering/ticketbilag';
static readonly getSigneringTicketDokumentPath = '/signering/ticketdokument';
static readonly getDigitalSigneringRequestMitIdPath = '/signering/request/mitid';
static readonly validerDigitalSigneringMitIdPath = '/signering/valider/mitid';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param ticket undefined
   * @return Success
   */
  private getAnmodningResponse(ticket: string): __Observable<__StrictHttpResponse<SigneringAnmodningInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (ticket != null) __params = __params.set('ticket', ticket.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/signering/anmodning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SigneringAnmodningInfo>;
      })
    );
  }

  /**
   * @param ticket undefined
   * @return Success
   */
  getAnmodning(ticket: string): __Observable<SigneringAnmodningInfo> {
    return this.getAnmodningResponse(ticket).pipe(
      __map(_r => _r.body as SigneringAnmodningInfo)
    );
  }

  /**
   * @param signering undefined
   * @return Success
   */
  private orderResponse(signering?: OrderSignering): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = signering;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/signering/anmodning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param signering undefined
   * @return Success
   */
  order(signering?: OrderSignering): __Observable<string> {
    return this.orderResponse(signering).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `SigneringService.RevokeRequestParams` containing the following parameters:
   *
   * - `ticket`:
   *
   * - `dokumentationReference`:
   */
  private revokeRequestResponse(params: SigneringService.RevokeRequestParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ticket != null) __params = __params.set('ticket', params.ticket.toString());
    __body = params.dokumentationReference;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/signering/anmodning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `SigneringService.RevokeRequestParams` containing the following parameters:
   *
   * - `ticket`:
   *
   * - `dokumentationReference`:
   */
  revokeRequest(params: SigneringService.RevokeRequestParams): __Observable<null> {
    return this.revokeRequestResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `SigneringService.DownloadParams` containing the following parameters:
   *
   * - `projektVersion`:
   *
   * - `filId`:
   *
   * - `dokumentationId`:
   *
   * @return Success
   */
  private downloadResponse(params: SigneringService.DownloadParams): __Observable<__StrictHttpResponse<FileStreamResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.projektVersion != null) __params = __params.set('projektVersion', params.projektVersion.toString());
    if (params.filId != null) __params = __params.set('filId', params.filId.toString());
    if (params.dokumentationId != null) __params = __params.set('dokumentationId', params.dokumentationId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/signering/dokument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * @param params The `SigneringService.DownloadParams` containing the following parameters:
   *
   * - `projektVersion`:
   *
   * - `filId`:
   *
   * - `dokumentationId`:
   *
   * @return Success
   */
  download(params: SigneringService.DownloadParams): __Observable<FileStreamResult> {
    return this.downloadResponse(params).pipe(
      __map(_r => _r.body as FileStreamResult)
    );
  }

  /**
   * Uploader manuel signeringsbevis på signaturanmodning.
   * @param params The `SigneringService.UploadParams` containing the following parameters:
   *
   * - `sagId`: Sagens ID.
   *
   * - `projektVersionNr`: Projekts VersionsNr.
   *
   * - `projektId`: Projektets ID.
   *
   * - `dokumentationId`: Dokumentation ID.
   *
   * - `fileInput`:
   *
   * @return Success
   */
  private uploadResponse(params: SigneringService.UploadParams): __Observable<__StrictHttpResponse<SigneringBilag>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.sagId != null) __params = __params.set('sagId', params.sagId.toString());
    if (params.projektVersionNr != null) __params = __params.set('projektVersionNr', params.projektVersionNr.toString());
    if (params.projektId != null) __params = __params.set('projektId', params.projektId.toString());
    if (params.dokumentationId != null) __params = __params.set('dokumentationId', params.dokumentationId.toString());
    if (params.fileInput != null) { __formData.append('fileInput', params.fileInput as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/signering/dokument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SigneringBilag>;
      })
    );
  }

  /**
   * Uploader manuel signeringsbevis på signaturanmodning.
   * @param params The `SigneringService.UploadParams` containing the following parameters:
   *
   * - `sagId`: Sagens ID.
   *
   * - `projektVersionNr`: Projekts VersionsNr.
   *
   * - `projektId`: Projektets ID.
   *
   * - `dokumentationId`: Dokumentation ID.
   *
   * - `fileInput`:
   *
   * @return Success
   */
  upload(params: SigneringService.UploadParams): __Observable<SigneringBilag> {
    return this.uploadResponse(params).pipe(
      __map(_r => _r.body as SigneringBilag)
    );
  }

  /**
   * @param params The `SigneringService.DeleteSigneringDokumentParams` containing the following parameters:
   *
   * - `projektVersion`:
   *
   * - `dokumentationId`:
   *
   * - `filId`:
   */
  private deleteSigneringDokumentResponse(params: SigneringService.DeleteSigneringDokumentParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.projektVersion != null) __params = __params.set('projektVersion', params.projektVersion.toString());
    if (params.dokumentationId != null) __params = __params.set('dokumentationId', params.dokumentationId.toString());
    if (params.filId != null) __params = __params.set('filId', params.filId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/signering/dokument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `SigneringService.DeleteSigneringDokumentParams` containing the following parameters:
   *
   * - `projektVersion`:
   *
   * - `dokumentationId`:
   *
   * - `filId`:
   */
  deleteSigneringDokument(params: SigneringService.DeleteSigneringDokumentParams): __Observable<null> {
    return this.deleteSigneringDokumentResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `SigneringService.GetSigneringTicketBilagParams` containing the following parameters:
   *
   * - `ticket`:
   *
   * - `bilagId`:
   *
   * @return Success
   */
  private getSigneringTicketBilagResponse(params: SigneringService.GetSigneringTicketBilagParams): __Observable<__StrictHttpResponse<FileStreamResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ticket != null) __params = __params.set('ticket', params.ticket.toString());
    if (params.bilagId != null) __params = __params.set('bilagId', params.bilagId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/signering/ticketbilag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * @param params The `SigneringService.GetSigneringTicketBilagParams` containing the following parameters:
   *
   * - `ticket`:
   *
   * - `bilagId`:
   *
   * @return Success
   */
  getSigneringTicketBilag(params: SigneringService.GetSigneringTicketBilagParams): __Observable<FileStreamResult> {
    return this.getSigneringTicketBilagResponse(params).pipe(
      __map(_r => _r.body as FileStreamResult)
    );
  }

  /**
   * @param ticket undefined
   * @return Success
   */
  private getSigneringTicketDokumentResponse(ticket: string): __Observable<__StrictHttpResponse<FileStreamResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (ticket != null) __params = __params.set('ticket', ticket.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/signering/ticketdokument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * @param ticket undefined
   * @return Success
   */
  getSigneringTicketDokument(ticket: string): __Observable<FileStreamResult> {
    return this.getSigneringTicketDokumentResponse(ticket).pipe(
      __map(_r => _r.body as FileStreamResult)
    );
  }

  /**
   * @param ticket undefined
   * @return Success
   */
  private getDigitalSigneringRequestMitIdResponse(ticket?: string): __Observable<__StrictHttpResponse<MitIdSigneringRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (ticket != null) __params = __params.set('ticket', ticket.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/signering/request/mitid`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MitIdSigneringRequest>;
      })
    );
  }

  /**
   * @param ticket undefined
   * @return Success
   */
  getDigitalSigneringRequestMitId(ticket?: string): __Observable<MitIdSigneringRequest> {
    return this.getDigitalSigneringRequestMitIdResponse(ticket).pipe(
      __map(_r => _r.body as MitIdSigneringRequest)
    );
  }

  /**
   * @param validerSigneringRequest undefined
   * @return Success
   */
  private validerDigitalSigneringMitIdResponse(validerSigneringRequest: ValiderSigneringRequest): __Observable<__StrictHttpResponse<ValiderSigneringResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = validerSigneringRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/signering/valider/mitid`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ValiderSigneringResult>;
      })
    );
  }

  /**
   * @param validerSigneringRequest undefined
   * @return Success
   */
  validerDigitalSigneringMitId(validerSigneringRequest: ValiderSigneringRequest): __Observable<ValiderSigneringResult> {
    return this.validerDigitalSigneringMitIdResponse(validerSigneringRequest).pipe(
      __map(_r => _r.body as ValiderSigneringResult)
    );
  }
}

module SigneringService {

  /**
   * Parameters for revokeRequest
   */
  export interface RevokeRequestParams {
    ticket: string;
    dokumentationReference: DokumentationReference;
  }

  /**
   * Parameters for download
   */
  export interface DownloadParams {
    projektVersion: number;
    filId: string;
    dokumentationId: string;
  }

  /**
   * Parameters for upload
   */
  export interface UploadParams {

    /**
     * Sagens ID.
     */
    sagId: string;

    /**
     * Projekts VersionsNr.
     */
    projektVersionNr: number;

    /**
     * Projektets ID.
     */
    projektId: string;

    /**
     * Dokumentation ID.
     */
    dokumentationId: string;
    fileInput?: Blob;
  }

  /**
   * Parameters for deleteSigneringDokument
   */
  export interface DeleteSigneringDokumentParams {
    projektVersion: number;
    dokumentationId: string;
    filId?: string;
  }

  /**
   * Parameters for getSigneringTicketBilag
   */
  export interface GetSigneringTicketBilagParams {
    ticket: string;
    bilagId?: string;
  }
}

export { SigneringService }
